module.exports = __webpack_public_path__ + "static/nxrt-esports2-c3041ba32bd28cbe480f931711db51cf.jpg";